import { deleteAttachments } from '../api/attachment_apis';
import { STATUS } from '../api/sharedfunction';

const attachmentCallBackDelete = async (attachmentIds) => {
  if (!attachmentIds || attachmentIds.length === 0) return;
  
  try {
    const response = await deleteAttachments({ attachmentIds });
    
    if (response.status === STATUS.SUCCESS) {
      console.log('Attachments deleted successfully:', response.message);
      return response;
    } else {
      console.error('Error deleting attachments:', response.error);
      return response;
    }
  } catch (error) {
    console.error('Error deleting attachments:', error.message);
    return {
      status: STATUS.ERROR,
      error: error.message || 'Failed to delete attachments'
    };
  }
};

export default attachmentCallBackDelete;
